import { call, put, select, takeLatest } from "redux-saga/effects";
import apiNoAuth from "~/services/apiNoAuth";
import apiJson from "~/services/apiJson";
import api from "~/services/api";
import { Types as PromoTypes } from "./actions";
import { Types as AuthenticationTypes } from "../authentication/actions";
import { variables } from "~/utils/variables";
import { urlEncode } from "~/utils/tools";
import history from "~/routes/history";
import MESSAGES from "~/utils/messages";

export function* getCSRFToken() {
  try {
    const { data } = yield call(apiNoAuth.post, "/promo/geral/getCSRFToken");
    return data;
  } catch (err) {
    console.error("Error fetching CSRF token:", err);
    return null;
  }
}

export function* getNurseries() {
  try {
    const payload = {
      Token: process.env.REACT_APP_PROMO_TOKEN,
    };
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/promo/maternidade/listar",
      payloadValues
    );
    if (data.sucesso) {
      yield put({ type: PromoTypes.GET_NURSERIES_SUCCESS, payload: data });
    } else {
      yield put({ type: PromoTypes.GET_NURSERIES_FAIL, payload: data });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_NURSERIES_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getInterests() {
  try {
    const payload = {
      Token: process.env.REACT_APP_PROMO_TOKEN,
    };
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/promo/interesses/listar",
      payloadValues
    );
    if (data.sucesso) {
      yield put({ type: PromoTypes.GET_INTERESTS_SUCCESS, payload: data });
    } else {
      yield put({ type: PromoTypes.GET_INTERESTS_FAIL, payload: data });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_INTERESTS_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* sendRegister({ payload }) {
  try {
    payload.Device = navigator.userAgent;
    payload.ConnectHash = variables.connectHash;
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    payload.PremioId = 1;
    payload.ParticipanteHash = yield select(
      (state) => state.authentication.auth.user.ParticipanteHash
    );
    payload.LoginToken = yield select(
      (state) => state.authentication.auth.loginToken
    );

    const { data } = yield call(
      apiJson.post,
      "/promo/participante/cadastrar-participante-maternidade",
      payload
    );
    if (data.sucesso) {
      yield put({ type: PromoTypes.SEND_REGISTER_SUCCESS, payload: data });
      yield put({
        type: AuthenticationTypes.SET_COMPLETE_SIGNUP,
        payload: data,
      });
      yield history.push({
        pathname: "/cadastro-concluido",
        search: window.location.search,
      });
    } else {
      yield put({
        type: PromoTypes.SEND_REGISTER_FAIL,
        payload: { msg: data.msg },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.SEND_REGISTER_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getPAT({ payload }) {
  try {
    const payload = {
      Device: navigator.userAgent,
      Token: process.env.REACT_APP_PROMO_TOKEN,
      ConnectHash: variables.connectHash,
      LoginToken: yield select((state) => state.authentication.auth.loginToken),
      ParticipanteHash: yield select(
        (state) => state.authentication.auth.user.ParticipanteHash
      ),
    };

    const { data } = yield call(
      apiJson.post,
      "/promo/participante/listar-sugestoes-maternidade",
      payload
    );
    if (data.sucesso) {
      const user = yield select((state) => state.authentication.auth.user);
      yield put({
        type: PromoTypes.GET_PAT_SUCCESS,
        payload: { ...data, user },
      });
    } else {
      yield put({
        type: PromoTypes.GET_PAT_FAIL,
        payload: { msg: data.msg },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_PAT_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getExistingUser({ payload }) {
  try {
    payload.Device = navigator.userAgent;
    payload.ConnectHash = variables.connectHash;
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    payload.ParticipanteHash = yield select(
      (state) => state.authentication.auth.user.ParticipanteHash
    );
    payload.LoginToken = yield select(
      (state) => state.authentication.auth.loginToken
    );
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/engine/participante/existe",
      payloadValues
    );
    if (data.sucesso) {
      yield put({ type: PromoTypes.GET_EXISTING_USER_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.GET_EXISTING_USER_FAIL,
        payload: { msg: data.msg },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_EXISTING_USER_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* registerPurchase({ payload }) {
  const csrfToken = yield call(getCSRFToken);

  try {
    payload.Device = navigator.userAgent;
    payload.ConnectHash = variables.connectHash;
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    payload.ParticipantePromoHash = yield select(
      (state) => state.authentication.auth.user.ParticipantePromoHash
    );
    payload.LoginToken = yield select(
      (state) => state.authentication.auth.loginToken
    );
    const payloadValues = urlEncode(payload);

    const { data } = yield call(
      api.post,
      "promo/mecanica-cupom/enviar-cupom-premio-instaneo",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );

    if (data?.sucesso) {
      yield put({
        type: PromoTypes.SEND_REGISTER_PURCHASE_SUCCESS,
        payload: data,
      });
    } else {
      yield put({
        type: PromoTypes.SEND_REGISTER_PURCHASE_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.SEND_REGISTER_PURCHASE_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getListPurshase({ payload }) {
  const csrfToken = yield call(getCSRFToken);
  try {
    payload.ConnectHash = variables.connectHash;
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    payload.Device = navigator.userAgent;
    payload.ParticipanteHash = yield select(
      (state) => state.authentication.auth.user.ParticipanteHash
    );
    payload.ParticipantePromoHash = yield select(
      (state) => state.authentication.auth.user.ParticipantePromoHash
    );
    payload.LoginToken = yield select(
      (state) => state.authentication.auth.loginToken
    );
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/promocao/premio-instantaneo/listar",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );
    if (data.sucesso) {
      yield put({ type: PromoTypes.GET_LIST_PURCHASE_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.GET_LIST_PURCHASE_FAIL,
        payload: { msg: data.msg },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_LIST_PURCHASE_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* setRaffle({ payload }) {
  try {
    payload.ConnectHash = variables.connectHash;
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    payload.Device = navigator.userAgent;
    payload.ParticipantePromoHash = yield select(
      (state) => state.authentication.auth.user.ParticipantePromoHash
    );
    payload.LoginToken = yield select(
      (state) => state.authentication.auth.loginToken
    );
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/promo/participante/tentar-a-sorte",
      payloadValues
    );
    if (data?.sucesso) {
      yield put({ type: PromoTypes.SET_RAFFLE_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.SET_RAFFLE_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.SET_RAFFLE_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getListWinners() {
  try {
    const payload = {
      ConnectHash: variables.connectHash,
      Token: process.env.REACT_APP_PROMO_TOKEN,
      Device: navigator.userAgent,
      Numero: "N",
    };

    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/promocao/ganhador/listar-ganhadores",
      payloadValues
    );
    if (data?.sucesso) {
      yield put({ type: PromoTypes.GET_LIST_WINNERS_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.GET_LIST_WINNERS_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_LIST_WINNERS_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getListProducts() {
  const csrfToken = yield call(getCSRFToken);
  try {
    const payload = {
      Token: process.env.REACT_APP_PROMO_TOKEN,
    };

    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/promocao/produto/listar-produto/",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );
    if (data?.sucesso) {
      yield put({ type: PromoTypes.GET_PRODUCTS_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.GET_PRODUCTS_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_PRODUCTS_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getListSellers() {
  const csrfToken = yield call(getCSRFToken);
  try {
    const payload = {
      Token: process.env.REACT_APP_PROMO_TOKEN,
    };

    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      apiNoAuth.post,
      "/promocao/fornecedor/listar",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );
    if (data?.sucesso) {
      yield put({ type: PromoTypes.GET_SELLERS_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.GET_SELLERS_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    yield put({
      type: PromoTypes.GET_SELLERS_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* setlinkGift({ payload }) {
  const csrfToken = yield call(getCSRFToken);
  try {
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    payload.ConnectHash = variables.connectHash;
    payload.ParticipantePromoHash = yield select(
      (state) => state.authentication.auth.user.ParticipantePromoHash
    );

    payload.LoginToken = yield select(
      (state) => state.authentication.auth.loginToken
    );
    const payloadValues = urlEncode(payload);

    const { data } = yield call(
      apiNoAuth.post,
      "/promo/brindes/vincula-brinde",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );
    if (data?.sucesso) {
      yield put({ type: PromoTypes.SEND_LINK_GIFT_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.SEND_LINK_GIFT_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    console.log(err);
    yield put({
      type: PromoTypes.SEND_LINK_GIFT_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getGift() {
  const csrfToken = yield call(getCSRFToken);
  try {
    const payload = {};
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    payload.ConnectHash = variables.connectHash;
    payload.ParticipantePromoHash = yield select(
      (state) => state.authentication.auth.user.ParticipantePromoHash
    );

    payload.LoginToken = yield select(
      (state) => state.authentication.auth.loginToken
    );
    const payloadValues = urlEncode(payload);

    const { data } = yield call(
      apiNoAuth.post,
      "/promo/brindes/buscar-brinde",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );
    if (data?.sucesso) {
      yield put({ type: PromoTypes.GET_GIFT_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.GET_GIFT_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    console.log(err);
    yield put({
      type: PromoTypes.GET_GIFT_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* getFAQ() {
  const csrfToken = yield call(getCSRFToken);
  try {
    const payload = {};
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    const payloadValues = urlEncode(payload);

    const { data } = yield call(
      apiNoAuth.post,
      "/promo/sincronizar/importar-duvidas-frequentes",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );
    if (data?.sucesso) {
      yield put({ type: PromoTypes.GET_FAQ_SUCCESS, payload: data });
    } else {
      yield put({
        type: PromoTypes.GET_FAQ_FAIL,
        payload: { msg: data?.msg || MESSAGES.genericError },
      });
    }
  } catch (err) {
    console.log(err);
    yield put({
      type: PromoTypes.GET_FAQ_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export default function* saga() {
  yield takeLatest(PromoTypes.GET_NURSERIES, getNurseries);
  yield takeLatest(PromoTypes.GET_INTERESTS, getInterests);
  yield takeLatest(PromoTypes.SEND_REGISTER, sendRegister);
  yield takeLatest(PromoTypes.GET_PAT, getPAT);
  yield takeLatest(PromoTypes.GET_EXISTING_USER, getExistingUser);
  yield takeLatest(PromoTypes.SEND_REGISTER_PURCHASE, registerPurchase);
  yield takeLatest(PromoTypes.GET_LIST_PURCHASE, getListPurshase);
  yield takeLatest(PromoTypes.SET_RAFFLE, setRaffle);
  yield takeLatest(PromoTypes.GET_LIST_WINNERS, getListWinners);
  yield takeLatest(PromoTypes.GET_PRODUCTS, getListProducts);
  yield takeLatest(PromoTypes.GET_SELLERS, getListSellers);
  yield takeLatest(PromoTypes.SEND_LINK_GIFT, setlinkGift);
  yield takeLatest(PromoTypes.GET_GIFT, getGift);
  yield takeLatest(PromoTypes.GET_FAQ, getFAQ);
}
